import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useScope } from '../context/ScopeContext';

/**
 * Carries `?curriculum=…` across in-app navigation.
 *
 * ScopeProvider sits ABOVE the router (it has to: it feeds CourseProvider,
 * which every route reads), so it can only read the URL the page arrived on.
 * A link clicked inside the app never reloads the page — the IEB page's
 * "Sign up free" goes to /signup?curriculum=IEB without a round trip — so the
 * parameter used to be carried there and ignored. This renders nothing and
 * hands each new query string to the provider.
 */
export const ScopeUrlSync: React.FC = () => {
  const { search } = useLocation();
  const { absorbSearch } = useScope();
  useEffect(() => {
    absorbSearch(search);
  }, [search, absorbSearch]);
  return null;
};
